import { render, staticRenderFns } from "./DriversFieldEditForm.vue?vue&type=template&id=0ee28964&scoped=true&"
import script from "./DriversFieldEditForm.vue?vue&type=script&lang=js&"
export * from "./DriversFieldEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversFieldEditForm.vue?vue&type=style&index=0&id=0ee28964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee28964",
  null
  
)

export default component.exports